import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/Rank/siteType",{ ...params
    } )
}
function EXPORT(params) {
    return  axios.post("/statistics/Rank/siteTypeExport",{...params
    }  )
}

export default {
    GET_LIST,
    EXPORT,
};
